import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import ContextPaneTitle from './ContextPaneTitle'
import ContextPaneDescription from './ContextPaneDescription'
import OwnerInfoBox from './OwnerInfoBox'
import RelatedLinksBox from './RelatedLinksBox'
//import { RecentVisitors } from './RecentVisitors'

const StyledDiv = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  padding-left: 15px;
  padding-right: 15px;
`

class ContextPane extends React.Component {
  render() {
    return (
      <StyledDiv>
        <ContextPaneTitle elementTitle={this.props.name} />
        <ContextPaneDescription elementDescription={this.props.description} />
        <OwnerInfoBox ownerInfo={this.props.owner_email} />
        <RelatedLinksBox
          relatedLinks={this.props.related_links}
          docLinks={this.props.documentation}
        />
        {/*<RecentVisitors recentVisitors={this.props.seletedElement.recentVisitors} />*/}
      </StyledDiv>
    )
  }
}

function mapStateToProps(state, ownProps) {
  return {
    ...state.dataDirectory.currentElement,
    ...ownProps,
  }
}

export default connect(mapStateToProps)(ContextPane)
